import {Protocol} from "./Protocols";
import {ObjectRetranslationModel} from "./ObjectRetranslationModel";

export enum RetranslationStatus
{
  Inactive = 0,
  Active = 1,
  //Completed = 2,
  //ErrorStopped = 3
}

export class RetranslationViewModel {
  Id: number = 0;
  Name: string = "";
  Protocol: Protocol = Protocol.WialonIPS;
  Status: RetranslationStatus;
  ServerAddress: string = "";
  ServerPort: number = 0;
  From: number = Date.now();
  Till?: number | null = null;
  Objects: ObjectRetranslationModel[] = [];

  IsChecked: boolean = false;

  constructor(data?: any) {
    if (data) {
      this.init(data);
    }
  }

  init(data: any): void {
    this.Id = data.id || 0;
    this.Name = data.name || "";
    this.Protocol = data.protocol;
    this.Status = <RetranslationStatus>data.status ?? RetranslationStatus.Inactive;
    this.ServerAddress = data.serverAddress || "";
    this.ServerPort = data.serverPort || 0;
    this.From = data.from || Date.now();
    this.Till = data.till ?? null;

    if (data["objects"])
      data["objects"].forEach(x => {
        this.Objects.push(ObjectRetranslationModel.fromJS(x));
      })
    this.IsChecked = data.isChecked || false;
  }

  static fromJS(data: any): RetranslationViewModel {
    return new RetranslationViewModel(data);
  }

  getObjectIds() {
    return this.Objects.map(o => o.ObjectId);
  }
}
